module.exports = __webpack_public_path__ + "img/8_30.af28de2d.png";